var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgAppIcon = function SvgImgAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4.667,
    fill: "#0AAF82"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#img_app_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img_app_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.347 13.172a1.181 1.181 0 0 0 0 1.658l1.657 1.667 1.657-1.667a1.181 1.181 0 0 0 0-1.658l-1.656-1.665-1.658 1.665ZM17.291 7.394l-.005-.005-3.285-3.306-6.584 6.623c-1.8 1.81-1.8 4.775 0 6.586l.017.017 9.857-9.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.811 15.098c-.6-.603-.6-1.59 0-2.193l-4.377 4.404 2.881 2.9 3.29-3.31c-.013-.01-1.794-1.8-1.794-1.8v-.001Z",
    fill: "url(#img_app_icon_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.692 7.797-3.289 3.308 1.792 1.8c.6.603.6 1.59 0 2.193l4.377-4.404-2.88-2.897Z",
    fill: "url(#img_app_icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.572 10.694-9.856 9.917L14 23.916l6.582-6.624c1.8-1.812 1.8-4.776 0-6.587l-.01-.01Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_app_icon_svg__c",
    x1: 12.457,
    y1: 17.958,
    x2: 9.738,
    y2: 15.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "img_app_icon_svg__d",
    x1: 15.423,
    y1: 9.917,
    x2: 18.412,
    y2: 12.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "img_app_icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.066 4.083)",
    d: "M0 0h15.867v19.833H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "img_app_icon_svg__a",
    x: 5.133,
    y: 4.083,
    width: 17.733,
    height: 21.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.933
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.467
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28884_24009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_28884_24009",
    result: "shape"
  })))));
};
export default SvgImgAppIcon;